$(function() {
    var dirRtlFlag = false;
    if ($("html").attr('dir') == 'rtl') {
        dirRtlFlag = true;
    }

    // $('.homepage-slider').slick({
    //     dots: true,
    //     infinite: true,
    //     speed: 1000,
    //     rtl: dirRtlFlag,
    //     arrows: false,
    //     autoplay: true,
    //     autoplaySpeed: 5000,
    //     pauseOnHover: false,
    //     fade: true 
    // });
});

// $(window).scroll(function()
// 		{
// 			var x = $(this).scrollTop(); // scroll pos
// 			var y = $("html").height();
// 			var z = x / y;

// 			curTop = ((z*500));
//       curTop2 = ((z*500)-20);
// 			$(".homepage-slider").css("top", (curTop)+"px");
//       $(".inner-banner").css("top", (curTop)+"px");
// 		});
